import '@telus-uds/palette-allium/build/web/fonts/fonts-cdn.css'

import TelusMediaReleasePage from '../../../../../siteBuilder/mediaReleases/TelusMediaReleasePage'
import { createGetServerSideProps } from '../../../../../siteBuilder/mediaReleases/createMediaReleaseGetServerSideProps'

export default TelusMediaReleasePage
export const getServerSideProps = createGetServerSideProps('about/news-and-events/media-releases/')
